module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-home inner-page"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', {
    staticClass: "inner-page-wrap"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "main-slider"
    }
  }, [(_vm.props.acf.homepage_slider) ? _c('swiper', {
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.props.acf.homepage_slider), function(Homeslider) {
    return _c('swiper-slide', [(Homeslider.url) ? _c('div', {
      staticClass: "item",
      style: ({
        backgroundImage: 'url(' + Homeslider.url + ')'
      })
    }) : _vm._e()])
  }), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2) : _vm._e(), _c('div', {
    staticClass: "hero-rectangle-section"
  }, [_c('div', {
    staticClass: "hero-rectangle-left"
  }, [(_vm.props.acf.rectangle_left_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.rectangle_left_img,
      "alt": ""
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "hero-rectangle-right"
  }, [(_vm.props.acf.rectangle_right_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.rectangle_right_img,
      "alt": ""
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "main-slider-text"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.props.acf.home_slider_title) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_slider_title)
    }
  }) : _vm._e(), (_vm.props.acf.home_slider_subtitle) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_slider_subtitle)
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "slider-overlay"
  })], 1), _c('div', {
    staticClass: "homeabout"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.props.acf.welcome_intro) ? _c('div', {
    staticClass: "section-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.welcome_intro)
    }
  }) : _vm._e(), (_vm.props.acf.welcome_video_iframe_src) ? _c('iframe', {
    attrs: {
      "src": _vm.props.acf.welcome_video_iframe_src,
      "width": "640",
      "height": "360",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  }) : _vm._e()])]), _vm._l((_vm.props.acf.services_list), function(ServiceList) {
    return _c('div', {
      staticClass: "homeservices"
    }, [(ServiceList.img_bg) ? _c('div', {
      staticClass: "homeservicesbg",
      style: ({
        backgroundImage: 'url(' + ServiceList.img_bg + ')'
      })
    }) : _vm._e(), _c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "homeservicestext"
    }, [(ServiceList.title) ? _c('h3', {
      domProps: {
        "innerHTML": _vm._s(ServiceList.title)
      }
    }) : _vm._e(), (ServiceList.content) ? _c('h5', {
      domProps: {
        "innerHTML": _vm._s(ServiceList.content)
      }
    }) : _vm._e(), (ServiceList.learn_more_url) ? _c('router-link', {
      staticClass: "view-more",
      attrs: {
        "to": ServiceList.learn_more_url
      }
    }, [(ServiceList.learn_more_text) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(ServiceList.learn_more_text)
      }
    }) : _vm._e(), _c('i', {
      staticClass: "fa fa-long-arrow-right"
    })]) : _vm._e()], 1)])])
  }), (_vm.props.acf.insta_section_bg) ? _c('div', {
    staticClass: "homewhy",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.insta_section_bg + ')'
    })
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section-heading"
  }, [(_vm.props.acf.insta_content) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.insta_content)
    }
  }) : _vm._e()])])]) : _vm._e(), _c('Footer')], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52208372","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 529
// module chunks = 1